import { cn } from '@chatsdet/ui';

import type { EffectivePlaybookData } from '../types/playbook-cache';

const CHIP = 'text-[10px] font-medium px-1.5 py-0.5 rounded';

export function EffectivePlaybookSummary({ playbook }: { playbook?: EffectivePlaybookData }) {
  if (!playbook) return null;

  const source =
    playbook.source === 'cache'
      ? { label: 'Cache playbook', title: 'This cache-row playbook will run' }
      : playbook.source === 'config_fallback'
        ? { label: 'Workflow fallback', title: 'The workflow-configured fallback will run' }
        : { label: 'No saved playbook', title: 'The agent will execute this node live' };

  return (
    <span className="inline-flex items-center gap-1 shrink-0">
      <span
        className={cn(CHIP, 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300')}
        title={source.title}
      >
        {source.label}
      </span>
      {playbook.inactiveCache && (
        <span
          className={cn(
            CHIP,
            'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
          )}
          title={`A cache row exists but will not run (${playbook.inactiveReason ?? 'inactive'})`}
        >
          Inactive cache
        </span>
      )}
    </span>
  );
}
